module.exports = __webpack_public_path__ + "img/pen.ab69f274.svg";